
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Cart } from '@/models/cart';

import ListCart from './ListCart.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

import commonService from '@/services/common-services';
import cartServices from '@/services/cart-services';
import authService from '@/services/auth-services';

import { APP_CONFIG } from '@/config/app-config';

const numeral = require('numeral');


@Component({
    components: {
        Loading,
        ListCart,
        ConfirmModal
    }
})
export default class ConfirmCart extends Vue {
    private feeBuyProRange: any;
    private isUseWallet = false;
    private isCheckPrice = true;
    private isConfirmWallet = false;
    private customerInfo: any = {};
    private isLoading = false;
    private listCart: Cart[] = [];
    private confirmCart: any = {};
    private cartStatus = 0;
    private chinaStoreID = 0;
    private receivePlaceID = 0;
    private addressBookID = 0;
    private listAddress: any[] = [];

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get param() {
        return this.$route.params.cartIds;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }
   
    get cartSelected() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].cartSelected;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    get feeGuarantee() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
    } 

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }
    
    private async getAddressBook() {
        const result = await authService.addressInfo(this.userInfo.userId);
        if (result && result.status === 200) {
            this.listAddress = result.data.data;
            const defaultAddr = this.listAddress.find((p) => p.IsDefault);
            this.addressBookID = defaultAddr ? defaultAddr.ID : 0;
        }
    }

    @Watch('isUseWallet', { immediate: true, deep: true })
    private async watchIsUseWallet() {
        this.isCheckPrice = !this.isUseWallet;
    }

    @Watch('isCheckPrice', { immediate: true, deep: true })
    private async watchIsCheckPrice() {
        this.isUseWallet = !this.isCheckPrice;
    }
    
    @Watch('customerInfo', { immediate: true, deep: true })
    private async watchCustomerInfo() {
        this.chinaStoreID = this.customerInfo.ChinaStoreID;
        this.receivePlaceID = this.customerInfo.ReceivePlaceID;
    }

    private async onUpdateConfirm(eventData: any) {
        await this.loadData();
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        if (!this.feeGuarantee) {
            await this.getFeeGuarantee();
        }
        if (this.listAddress.length === 0) {
            await this.getAddressBook();
        }
        await this.getCustomersInfo();
        await this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        if (this.cartSelected === null) {
            this.onComeback();
            return;
        }
        this.isLoading = true;
        const productIds = this.cartSelected.flatMap(cart => cart.products.map(pro => pro.id));
        let otherOptions = []
        if(this.confirmCart && this.confirmCart.Orders) {
            otherOptions = this.confirmCart.Orders.flatMap(cart => {return {'ShopID': cart.OrderShopTempID, 'IsFragileGoods': cart.IsFragileGoods, 'IsCheck': cart.IsCheck, 'CheckFeeType': cart.CheckFeeType, 'IsFast': cart.IsFast, 'GuaranteeType': cart.GuaranteeType}});
        }
        
        const result = await cartServices.cartConfirm(productIds, otherOptions);
        if (result && result.status === 200) {
            this.confirmCart = result.data.data;
            }
        this.isLoading = false;
    }

    private onCloseModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
    } 
    
    private onOtherModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'credit' });
        }
    }

    private onAcceptModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.pushData(false);
        }
    }

    private async submitData() {
        this.cartStatus = 0;
        if (this.isUseWallet === true) {
            if (this.customerInfo.Wallet < this.confirmCart.TotalDeposit) {
                this.isConfirmWallet = true;
                return;
            }
            this.cartStatus = 2;
        }

        this.pushData(this.isUseWallet);
    }

    private async pushData(isDeposit) {
        if (!this.addressBookID) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy chọn địa chỉ nhận hàng!',
            });
            return;
        }
        this.isLoading = true;
        const productIds = this.cartSelected.flatMap(cart => cart.products.map(pro => pro.id));
        const otherOptions = this.confirmCart.Orders.flatMap(cart => {return {'ShopID': cart.OrderShopTempID, 'IsFragileGoods': cart.IsFragileGoods, 'IsCheck': cart.IsCheck, 'CheckFeeType': cart.CheckFeeType, 'IsFast': cart.IsFast, 'GuaranteeType': cart.GuaranteeType}});
        const result = await cartServices.bulk_action(productIds, otherOptions, isDeposit, this.chinaStoreID, this.receivePlaceID, this.addressBookID);
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            await this.getCustomersInfo();
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: this.cartStatus === 2 ? 'Đơn hàng tạo thành công!' : 'Đơn hàng tạo thành công, vui lòng đặt cọc để mua hàng',
            });
            (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
            this.$router.push({ name: 'order' });
            this.isLoading = false;
        } else if (result && result.data.status === 202) {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: result.data.error,
                    duration: 5000
                });
                this.isLoading = false;
        } else {
            this.isLoading = false;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình đặt hàng, vui lòng liên hệ quản trị!',
            });
        }
    }

    private onComeback() {
        this.$router.push({ name: 'cart-index' });
    }
}
